import React, { useContext, useState } from "react";
import { MdOutlineDeleteForever } from "react-icons/md";
import { appContext } from "../../Context/AppContext";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import ConfirmationModal from "../Modals/ConfirmationModal";
import TherapyRequestService from "../../services/TherapyRequest";
import { PersonalInfo } from "./PersonalInfo";
export const SingleRequestRow = ({ props }: any) => {
  const { setChatId } = useContext(appContext);
  const navigate = useNavigate();
  const {
    userid,
    email,
    phone,
    fullname,
    age,
    gender,
    budget,
    code,
    profession,
    symptom,
    language,
    city,
    _id,
    coupon,
    status,
    total_booking,
    booking_by_code,
  } = props;
  // console.log(coupon);
  const options = [

    { value: '', label: 'Select Coupon' },
    { value: '65a1446d7a6f17418932d21c', label: 'MANOSHALACARES699' },
    { value: '65a1448f7a6f17418932d225', label: 'MANOSHALACARES1399' },
    { value: '65a144f37a6f17418932d23a', label: 'MANOSHALACARES1899' },

  ];
  // console.log(options.find(item => item.value === coupon)?.label.trim() === coupon.trim() ,options.find(item => item.label === coupon)?.label.trim());
  const [showingStatus, setShowingStatus] = useState(status);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedName, setSelectedName] = useState("");
  const [isSelectDisabled, setIsSelectDisabled] = useState(
    options.find((item) => item.label === coupon)?.label.trim() ===
      coupon.trim()
  );

  const handleChange = (event: any) => {
    setSelectedValue(event.target.value);
    setSelectedName(
      options.find((el) => el.value === event.target.value)?.label || ""
    );
    onOpen();
  };

  const handleConfirm = () => {
    TherapyRequestService.updateCoupon(_id, selectedName)
      .then((res: any) => {
        TherapyRequestService.updateUserList(selectedValue, userid).then(
          (res: any) => {
            setIsSelectDisabled(true);
          }
        );
      })
      .catch((error: any) => {
        console.log(error);
      });
  
    onClose();
  };

  const handleCancel = () => {
    setSelectedValue("");
    onClose();
  };

  const handleClick = () => {
    TherapyRequestService.updateRequest(
      _id,
      showingStatus === "PENDING" ? "APPROVED" : "PENDING"
    )
      .then((res: any) => {
        setShowingStatus(showingStatus === "PENDING" ? "APPROVED" : "PENDING");
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  // const isSelectDisabled = selectedValue !== '';
  const handleSendMessage = () => {
    setChatId(userid);
    navigate("/manoshalacare/chat");
  };
  return (
    <tr>
      <Tooltip
        label={
          <PersonalInfo
            name={fullname}
            email={email}
            phone={phone}
            gender={gender}
            code={code}
          />
        }
        placement="bottom-start"
      >
        <td>
          <p className="client_email">{email}</p>
        </td>
      </Tooltip>
      <td>{age}</td>
      <td>{city}</td>
      <td>{budget}</td>
      <td>{profession}</td>
      <td>{symptom}</td>
      <td>{language}</td>
      <td className="font-weight-bold">{booking_by_code}</td>
      <td className="font-weight-bold">{total_booking}</td>
      <td>
        <Menu>
          <MenuButton
            color={showingStatus === "PENDING" ? "orange" : "green"}
            fontWeight="bold"
          >
            {showingStatus} <ChevronDownIcon />
          </MenuButton>
          <MenuList>
            <MenuItem onClick={handleClick}>
              <Box
                color={showingStatus === "APPROVED" ? "orange" : "green"}
                fontWeight="bold"
              >
                {showingStatus === "PENDING" ? "APPROVED" : "PENDING"}
              </Box>
            </MenuItem>
          </MenuList>
        </Menu>
      </td>
      <td>
        {coupon === "" ? (
          <div>
            <Select
              value={selectedValue}
              onChange={handleChange}
              isDisabled={isSelectDisabled}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>

            <ConfirmationModal
              isOpen={isOpen}
              onClose={handleCancel}
              onConfirm={handleConfirm}
            />
          </div>
        ) : (
          coupon
        )}
      </td>
      <td>
        {" "}
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn action-btn"
            onClick={handleSendMessage}
          >
            Message
          </button>
        </div>
      </td>
    </tr>
  );
};
